import type { InputNumberProps } from 'core/components/ui/InputNumber';
import { InputNumber } from 'core/components/ui/InputNumber';

type MetersInputProps = {
  'data-distance-symbol': string;
} & InputNumberProps;

export function MetersInput(props: MetersInputProps): JSX.Element {
  const distanceSymbol = props?.['data-distance-symbol'] ?? '';
  return <InputNumber addonAfter={distanceSymbol} {...props} />;
}
